import { BrowserStorageType, Helper } from "../app/core/util/helper.js";
import { Sheet, SheetEventType } from "./sheet.js";
import { General, KeyboardShortcut } from "./general.js";
import { EventType } from "./eventManager.js";

export class SideTabs {
    private _helper = Helper;
    private _hasValue = Helper.hasValue;
    private _element: JQuery = null;
    private _headerElement: JQuery = null;
    private _tabsElement: JQuery = null;
    private _closeButtonElement: JQuery = null;
    private _verticalTabs: JQuery = null;
    private _sheetInfoTab: JQuery = null;
    private _contentWrapper: JQuery = null;
    private _tabs: Array<SideTabDescription> = [];
    private _storageKey = "__side-storage__";
    private _toggleCallbacks: Array<(isOpen: boolean) => void> = [];


    constructor(element: JQuery) {
        this._element = element;
        this._element.addClass(SideTabClasses.SideTabs).addClass(SideTabClasses.SideTabsClosed);

        this._headerElement = $("<div>").addClass(SideTabClasses.Header);
        this._tabsElement = $("<div>").addClass(SideTabClasses.TabsContainer);
        this._closeButtonElement = $("<div>").addClass(SideTabClasses.CloseButton).html('<i class="fa-regular fa-xmark-large fa-xl"></i>');//fa-fw 
        this._closeButtonElement.on("click", () => {
            this._element.addClass(SideTabClasses.SideTabsClosed);
            this._saveState(false);
            this._triggerToggleCallbacks(false);
        })
        this._headerElement.append(this._tabsElement);
        this._headerElement.append(this._closeButtonElement);

        this._contentWrapper = $("<div>").addClass(SideTabClasses.ContentElement);

        this._verticalTabs = $("<div>").addClass(SideTabClasses.VerticalTabsElement);

        this._element.append(this._headerElement);
        this._element.append(this._contentWrapper);
        this._element.append(this._verticalTabs);

        const state = this._getState();
        if (this._helper.hasValue(state)) {
            if (state.isOpen === true) {
                this._element.removeClass(SideTabClasses.SideTabsClosed);
            }
        } else {
            this._saveState(false);
        }


        this._sheetInfoTab = this.addTab({ name: "__sheetInfo", iconName: "eye", type: SideTabType.Global, onSelect: () => { } }, true);
        this._tabs[0].content.addClass(SideTabClasses.SheetInfo);

        //General.Events.bind(EventType.ShortCut, (shortcut: KeyboardShortcut) => {
        //    let close = shortcut.key === "i" && shortcut.ctrl && this._getState().isOpen;
        //    let open = shortcut.key === "i" && shortcut.ctrl && !this._getState().isOpen;
        //    if (close) {
        //        this._element.addClass(SideTabClasses.SideTabsClosed);
        //        this._saveState(false);
        //        this._triggerToggleCallbacks(false);
        //    }
        //});


    }


    private _triggerToggleCallbacks = (isOpen) => {
        this._toggleCallbacks.forEach(c => {
            c(isOpen);
        });
    }

    private _getState = () => {
        return this._helper.loadDataFromStorage(this._storageKey, BrowserStorageType.Local);
    }

    private _saveState = (isOpen: boolean) => {
        this._helper.saveDataToStorage(this._storageKey, { isOpen: isOpen }, false, BrowserStorageType.Local);
    }


    addTab = (config: { name: string, iconName?: string, type: SideTabType, onSelect: Function, sheet?: Sheet }, selected = false) => {
        const tab: SideTabDescription = {
            name: config.name,
            icon: config.iconName,
            onSelect: config.onSelect,
            type: config.type,
            sheet: this._hasValue(config.sheet) ? config.sheet : null,
            element: null,
            content: null,
            quick: null
        };
        this._tabs.push(tab);

        if (config.type === SideTabType.Global) {
            const content = $("<div>").addClass(SideTabClasses.TabContent).addClass(SideTabClasses.TabContentInactive);
            tab.content = content;
            this._contentWrapper.append(content);

            const elem = $("<div>").addClass(SideTabClasses.TabHeader).html("<i class='fal fa-" + config.iconName + " fa-fw' aria-hidden='true'></i>");
            tab.element = elem;
            if (this._tabs.length === 1) {
                elem.addClass(SideTabClasses.TabHeaderActive);
                config.onSelect();
            }

            const selectTab = (trigger: boolean) => {
                $("." + SideTabClasses.TabHeader, this._tabsElement).removeClass(SideTabClasses.TabHeaderActive);
                elem.addClass(SideTabClasses.TabHeaderActive);

                $("." + SideTabClasses.TabContent, this._contentWrapper).addClass(SideTabClasses.TabContentInactive);
                content.removeClass(SideTabClasses.TabContentInactive);

                if (trigger) {
                    config.onSelect();
                }
            }

            elem.on("click", () => selectTab(true));
            this._tabsElement.append(elem);

            const quick = $("<div>").addClass(SideTabClasses.VarticalTabButton).html("<i class='fal fa-" + config.iconName + " fa-fw' aria-hidden='true'></i>");
            tab.quick = quick;
            quick.on("click", () => {
                this._element.removeClass(SideTabClasses.SideTabsClosed);
                selectTab(true);
                this._saveState(true);
                this._triggerToggleCallbacks(true);
            });
            this._verticalTabs.append(quick);

            if (selected) {
                selectTab(false);
            }

            General.Events.bind(EventType.ShortCut, (shortcut: KeyboardShortcut) => {
                let handleDrawerChange = shortcut.key === "i" && shortcut.ctrl && !this.isHidden();
                if (handleDrawerChange) {
                    if (this.isOpen()) {
                        this.close();
                    } else {
                        this.open();
                    }
                }
            });

            return content;
        } else {
            const content = $("<div></div>").addClass(SideTabClasses.SheetInfoContent);
            tab.content = content;

            this._sheetInfoTab.append(content);
            config.sheet.bind(SheetEventType.Close, () => {
                this.removeTab(config.name);
            });

            return content;
        }
    }

    removeTab = (name: string) => {
        let idx = -1;
        this._tabs.forEach((t, i) => {
            if (t.name === name) {
                idx = i;
            }
        })

        if (idx !== -1) {
            const tab = this._tabs[idx];

            if (tab.type === SideTabType.Global) {
                tab.element.off();
                tab.element.remove();
                tab.quick.remove();
            }

            tab.content.remove();
            this._tabs.splice(idx, 1);

            let count = 0;

            this._tabs.forEach(t => {
                if (t.type === SideTabType.Sheet) {
                    count++;
                }
            });
        }
    }

    onToggle = (callback: (isOpen: boolean) => void) => {
        this._toggleCallbacks.push(callback);
    }

    deregisterToggle = (callback: (isOpen: boolean) => void) => {
        let idx = -1;

        for (var i = 0; i < this._toggleCallbacks.length; i++) {
            if (this._toggleCallbacks[i] === callback) {
                idx = i;
                break;
            }
        }

        if (idx > -1) {
            this._toggleCallbacks.splice(idx, 1);
        }
    }

    close = () => {
        if (!this._element.hasClass(SideTabClasses.SideTabsClosed)) {
            this._element.addClass(SideTabClasses.SideTabsClosed);
            this._triggerToggleCallbacks(false);
        }
    }

    open = () => {
        if (this._element.hasClass(SideTabClasses.SideTabsClosed) || this._element.hasClass(SideTabClasses.SideTabsHidden)) {
            this._element.removeClass(SideTabClasses.SideTabsClosed);
            this._element.removeClass(SideTabClasses.SideTabsHidden);
            this._triggerToggleCallbacks(true);
        }
    }

    hide = () => {
        this._element.addClass(SideTabClasses.SideTabsHidden);
    }

    show = () => {
        this._element.removeClass(SideTabClasses.SideTabsHidden);
    }

    isOpen = () => {
        return !this._element.hasClass(SideTabClasses.SideTabsClosed) && !this._element.hasClass(SideTabClasses.SideTabsHidden);
    }

    isHidden = () => {
        return this._element.hasClass(SideTabClasses.SideTabsHidden);
    }
}

enum SideTabClasses {
    SideTabs = "side-tabs",
    SideTabsClosed = "side-tabs--closed",
    SideTabsHidden = "side-tabs--hidden",
    Header = "side-tabs__header",
    TabsContainer = "side-tabs__tabs",
    TabHeader = "side-tabs__tab",
    TabHeaderActive = "side-tabs__tab--active",
    CloseButton = "side-tabs__close",
    ContentElement = "side-tabs__content",
    TabContent = "side-tabs__tab-content",
    TabContentInactive = "side-tabs__tab-content--innactive",
    VerticalTabsElement = "side-tabs__quick-view",
    VarticalTabButton = "side-tabs__quick-tab",
    SheetInfo = "side-tabs__sheet-info",
    SheetInfoContent = "side-tabs__sheet-info-content"
}

interface SideTabDescription {
    name: string;
    icon: string;
    type: SideTabType;
    onSelect: Function;
    sheet: Sheet;
    element: JQuery;
    content: JQuery;
    quick: JQuery;
}

export enum SideTabType {
    Global = 0, Sheet = 1
}